export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/b552ae94a3baa9664c4076d726380c66.svg";